import { GLOBAL } from 'saddlebag-browser';

const $window = GLOBAL.getWindow();
const branch = $window && $window.branch ? $window.branch : {};

export default branch;
